import React from 'react';

const BaseballCountBackground = ({ isMatch }) => {
  const translate = isMatch ? `translate(-19, -7)` : `translate(-13, -2)`;
  const d = isMatch ? 10 : 8;
  const r = d / 2;
  const circleX = isMatch ? 2 : 1;

  return (
    <g transform={translate}>
      {new Array(3).fill('').map((item, idx) => {
        const space = isMatch ? 14 : 9;
        const index = idx + 1;
        const width = index * space;

        return (
          <circle
            key={idx}
            transform={`translate(${width}, ${circleX})`}
            cx={d}
            cy={d}
            r={r}
            fill="#184316"
          ></circle>
        );
      })}
    </g>
  );
};
export default BaseballCountBackground;
